module.exports = __webpack_public_path__ + "img/Butterfly_00076.240521f8.png";